import React, { memo } from "react";

import { SvgIcon } from "@origin-digital/ods-icons";

const IconRoofArea = memo(() => {
  return (
    <>
      <SvgIcon
        data-id="icon-roof-area"
        size="small"
        viewBox="0 0 23 20"
        color="neutral"
      >
        <path
          d="M0.65332 20V12H2.65332V18H9.65332V20H0.65332ZM13.6533 20V18H20.6533V12H22.6533V20H13.6533ZM0.65332 8V0H9.65332V2H2.65332V8H0.65332ZM20.6533 8V2H13.6533V0H22.6533V8H20.6533Z"
          fill="#232323"
        />
      </SvgIcon>
    </>
  );
});

export { IconRoofArea };
